/**
 * 全局组件注册
 */

// 字典组件
import Dictionary from '@/components/Dictionary'
import DictionaryCheckBox from '@/components/Dictionary/checkBox'


export default {
  install(Vue) {
    Vue.component('Dictionary',Dictionary)
    Vue.component('DictionaryCheckBox',DictionaryCheckBox)
  }
}
